import { formatTime, formatDate } from "@/utils/";
import { taskLevelKeyValue, taskStatusKeyValue } from "@/utils/const.js";
import { mapGetters, mapState, mapMutations } from 'vuex';
var common = {
  data: function () {
    return {
    };
  },
  filters: {
    formatTime(ns) {
      return formatTime(ns);
    },
    formatDate(ns) {
      ns = ns * 1000;
      return formatDate(ns);
    },
    taskLevel(n) {
      return taskLevelKeyValue[n] || "";
    },
    taskStatusText(val) {
      return taskStatusKeyValue[val] || ''
    },
    taskLevelText(val) {
      return taskLevelKeyValue[val] || ''
    },
  },
  methods: {
    routeJump(path, parame) {
      this.$router.push({
        path: path,
        query: parame
      });
    },
    success(message) {
      this.$message({
        showClose: true,
        message: message,
        type: "success"
      });
    },
    error(message) {
      this.$message({
        showClose: true,
        message: message,
        type: "error"
      });
    },
    warning(message) {
      this.$message({
        showClose: true,
        message: message,
        type: "warning"
      });
    },
    // 把当前的时间转换为UTC表示
    formatUTCString(dateObj) {
      let year = dateObj.getUTCFullYear();
      let mounth = this.PadZero(dateObj.getUTCMonth() + 1);
      let day = this.PadZero(dateObj.getUTCDate());
      let hours = this.PadZero(dateObj.getUTCHours());
      let minutes = this.PadZero(dateObj.getUTCMinutes());
      return "UTC " + year + mounth + day + " " + hours + minutes;
    },
    // 把UTC表示转换为当前时间
    utcTOgmt(utcString) {
      if (!utcString) {
        return null;
      }
      // 拆分字符串
      let arr = utcString.split(" ");
      let year = arr[1].slice(0, 4);
      let mounth = arr[1].slice(4, 6) - 1;
      let day = arr[1].slice(6, 8);
      let hours = arr[2].slice(0, 2);
      let minutes = arr[2].slice(2, 4);
      return new Date(Date.UTC(year, mounth, day, hours, minutes));
    },
    //补零
    PadZero(str) {
      return new RegExp(/^\d$/g).test(str) ? `0${str}` : str;
    }
  }
};

export default common;
